import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const CheckIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props} viewBox="0 0 13 11">
    <title>Check</title>
    <polygon points="4.68 11 2.5 8.76 2.04 8.29 0 6.21 2.63 3.5 4.68 5.58 10.37 0 13 2.71 4.68 11" />
  </IconBase>
);
